/* global axios */
// NOTICE: KAPTION-INTEGRATION
// Secure Assignment Mode admin surfaces (group-visibility.MULTI_GROUP.*).
//
// Three read-only endpoints backing the visibility guardrails:
//   preflight()          — advisory summary (group-visibility.GUARDRAIL.5 +
//                          MULTI_GROUP.6): who is in several restricted groups, and
//                          who is in both a restricted and an open group.
//   agentGroupMemberships() — per-agent groups behind the effective-visibility
//                          surface (GUARDRAIL.4).
//   simulate()           — "what does this person actually see?", answered by the
//                          server running the REAL visibility rule (SIMULATOR.2).
import ApiClient from './ApiClient';

class KaptionGroupVisibilityAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  preflight() {
    return axios.get(`${this.baseUrl()}/kaption_group_visibility_preflight`);
  }

  agentGroupMemberships() {
    return axios.get(`${this.baseUrl()}/kaption_agent_group_memberships`);
  }

  simulate(userId) {
    return axios.get(`${this.baseUrl()}/kaption_visibility_simulation`, {
      params: { user_id: userId },
    });
  }
}

export default new KaptionGroupVisibilityAPI();
